
import React, { useEffect, useRef, useState } from 'react';
import { Marker, Popup, Polygon } from 'react-leaflet';
import '../../Optics/TerritoryFilter/styleFilter.css'
import { CONST_CANTON, CONST_HIGHWAY, icon3k, iconCoupling, iconHouse, iconHouseActivated, iconHouseNotActivated, iconSummit } from '../../Optics/Constants/ConstantsOptics';
import 'leaflet.markercluster';
// import DialogNodeDescroption from '../Dialog/DialogNode/DialogNodeDescroption';
import { groupMarkersByCanton, groupMarkersByVetka, getPolygonPoints } from '../../Optics/TerritoryFilter/GroupMarkersPolygon';
import { SERVICE_HOUSE_URL } from '../../Optics/OpticApiConfig';
import MarkerClusterGroup from 'react-leaflet-cluster';


const GetHousesMapLocation = ({
  layersVisibility,
  isLineDrawing,
  mapRef,
  cantonTerritory,
  showPolygonsCanton,
  showPolygonsArea,
  housesData,
  showHouses,
  showHousesActiv,
  showHousesNoActiv
}) => {

  const cantonPolygonColor = '#c9c9df'; 
  const cantonPolygonsRef = useRef([]);
  const areaPolygonsRef = useRef([]);
  const [zoomLevel, setZoomLevel] = useState(null);
  const [openModalNode, setOpenModalNode] = useState(null); 
  const [openModalNodeEnt, setOpenModalNodeEnt] = useState(null);
  const [zoomHouse, setZoomHouse] = useState(null);

  const isZoomHouse = zoomHouse > 15;


  // Группировка домов
  const markersByVetka = groupMarkersByVetka(housesData);
  const markersByCanton = groupMarkersByCanton(housesData);

  // Уникальные дома по HID с максимальным подъездом
  const uniqueHouses = Object.values(
    housesData.reduce((acc, house) => {
      if (!acc[house.hid] || acc[house.hid].entrance < house.entrance) {
        acc[house.hid] = house;
      }
      return acc;
    }, {})
  );


  // Установка стилей для полигонов
  useEffect(() => {
    cantonPolygonsRef.current.forEach(polygon => {
      polygon?.setStyle({
        fillOpacity: showPolygonsCanton ? 0.2 : 0,
        opacity: showPolygonsCanton ? 0.6 : 0,
      });
    });

    areaPolygonsRef.current.forEach(polygon => {
      polygon?.setStyle({
        fillOpacity: showPolygonsArea ? 0.2 : 0,
        opacity: showPolygonsArea ? 0.6 : 0,
      });
    });
  }, [showPolygonsCanton, showPolygonsArea]);

  // Отслеживание изменения зума
  useEffect(() => {
    if (mapRef.current) {
      const map = mapRef.current;

      const handleZoomChange = () => {
        const newZoom = map.getZoom();
        setZoomLevel(newZoom);
        setZoomHouse(newZoom);
      };

      setZoomLevel(map.getZoom());
      setZoomHouse(map.getZoom());

      map.on('zoomend', handleZoomChange);
      return () => {
        map.off('zoomend', handleZoomChange);
      };
    }
  }, [mapRef]);

  return (
    <>
      {/* Полигоны по кантону */}
      {showPolygonsCanton && Object.entries(markersByCanton).map(([canton, coordinates], index) => {
        const polygonPoints = getPolygonPoints(coordinates);
        return polygonPoints && (
          <Polygon
            key={`canton-${index}`}
            ref={el => cantonPolygonsRef.current[index] = el}
            positions={polygonPoints}
            color={cantonPolygonColor}
            fillOpacity={showPolygonsCanton ? 0.2 : 0}
            opacity={showPolygonsCanton ? 0.6 : 0}
          />
        );
      })}

      {/* Полигоны по ветке */}
      {showPolygonsArea && Object.entries(markersByVetka).map(([vetka, coordinates], index) => {
        const polygonPoints = getPolygonPoints(coordinates);
        const vetkaPolygonColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

        return polygonPoints && (
          <Polygon
            key={`vetka-${index}`}
            ref={el => areaPolygonsRef.current[index] = el}
            positions={polygonPoints}
            color={vetkaPolygonColor}
            fillOpacity={showPolygonsArea ? 0.2 : 0}
            opacity={showPolygonsArea ? 0.8 : 0}
          >
            <Popup className="custom-popup">
              <span style={{ color: '#363535', fontWeight: 'bold', fontSize: '15px' }}>Ветка: </span>
              <span style={{ color: 'black', fontWeight: 'bold', fontSize: '15px' }}>{vetka}</span>
            </Popup>
          </Polygon>
        );
      })}

      {/* Маркеры домов */}
      {/* <MarkerClusterGroup> */}
        {/* Маркеры домов */}
    <MarkerClusterGroup disableClusteringAtZoom={16}>
      {uniqueHouses
  .filter(house =>
    house.latitude &&
    house.longitude &&
    house.typeName === 'Жилой многоэтажный дом' &&
    (
      showHouses ||
      (showHousesActiv && house.statusName === 'Активирован') ||
      (showHousesNoActiv && house.statusName !== 'Активирован')
    )
  )
  .map((house, index) => {
    let iconToUse;

    if (house.rank === 3) {
      iconToUse = icon3k;
    } else if (house.rank === 1 || house.rank === 2) {
      iconToUse = iconSummit;
    } else {
      iconToUse = house.statusName === 'Активирован'
        ? iconHouseActivated
        : iconHouseNotActivated;
    }
  {/* {uniqueHouses
    .filter(house =>
      house.latitude &&
      house.longitude &&
      house.typeName === 'Жилой многоэтажный дом' &&
      (
        showHouses ||
        (showHousesActiv && house.statusName === 'Активирован') ||
        (showHousesNoActiv && house.statusName !== 'Активирован')
      )
    )
    .map((house, index) => {
      const iconToUse =
        house.statusName === 'Активирован'
          ? iconHouseActivated
          : iconHouseNotActivated; */}

      return (
        <Marker
          key={`house-${index}`}
          position={[house.latitude, house.longitude]}
          icon={iconToUse}
        >
          {!isLineDrawing && (
            <Popup className='custom-popupMap2'>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={iconToUse.options.iconUrl}
                  width="30"
                  height="30"
                  style={{ marginBottom: "5px" }}
                  alt="House"
                />
                <div>
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    <a
                      href={`${SERVICE_HOUSE_URL}?Id=${house.hid}`}
                      target="_blank"
                      style={{ fontWeight: 'bold', color: "black" }}
                    >
                      {house.street}, дом. {house.numberHouse}
                    </a>
                  </span>
                  <br />
                  <hr className='horizontalLineFilter' />
                  <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                    ID: <span style={{ color: '#535353', fontWeight: 'normal' }}>{house.hid}</span>
                  </label><br />
                  <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                    Подъездов:<span style={{ color: '#6d0404', fontWeight: 'normal' }}> {house.entrance}</span>
                  </span><br />
                  <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                    ПАБ: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.apartments}</span>
                  </label><br />
                  <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                    Статус: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.statusName}</span>
                  </label><br />
                  <hr className='horizontalLineFilter' style={{ height: "1px" }} />
                </div>
              </div>
            </Popup>
          )}
        </Marker>
      );
    })}
</MarkerClusterGroup>
      {/* </MarkerClusterGroup> */}
    </>
  );
};

export default GetHousesMapLocation;